import React, { forwardRef } from "react";
import Button from "../../Button";
import ModuleStatusLabel from "../../CommonComponents/ModuleStatusLabel";
import ReactQuill from "react-quill";
import { GridIcon } from "./ChapterItem";
import IconButton from "../../CommonComponents/IconButton";
import Tooltip from "../../CommonComponents/Tooltip";
import { useState } from "react";
import Modal from "../../CommonComponents/Modal";
import ModalBody from "../../CommonComponents/ModalBody";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import useAuth from "../../../Hooks/useAuth";
import { RESULT_STATUS } from "../../../constants";
import { useParams } from "react-router-dom";
import Toast from "../../CommonComponents/Toast";

const Module = forwardRef(
  (
    {
      item = {},
      onClick = null,
      style = {},
      onDelete = null,
      onPreview = null,
      isSharedLP = 0,
    },
    ref,
  ) => {
    const axios = useAxiosPrivate();
    const { setShowNotify } = useAuth();
    const { lpid } = useParams();

    console.log("item in module", item);

    const [disableDelete, setDisableDelete] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [openToast, setOpenToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastType, setToastType] = useState("error");

    const onDeleteModule = async (event) => {
      event.stopPropagation();
      setOpenModal(true);
    };

    const onConfirmDeleteModule = async (moduleId) => {
      setDisableDelete(true);
      try {
        const { data } = await axios.delete(
          `node/admin/module/${moduleId}?lpId=${lpid}&scope=module`,
        );
        if (data.resultCode !== RESULT_STATUS.SUCCESS) {
          throw new Error(
            data.msg ?? `Unable to delete module. Please try again later`,
          );
        }
        setToastType("success");
        setToastMessage("Module deleted successfully.");
        setOpenToast(true);
        setOpenModal(false);
        onDelete && onDelete(moduleId);
      } catch (error) {
        console.log("error in delete module", error);
        let isUnAuth = error.message.includes("403");
        if (isUnAuth) {
          setShowNotify({
            isUnAuth,
            title: "Warning !",
            msg: "You have been logged-out due to inactivity. Login again.",
            show: true,
          });
          setOpenModal(false);
          return;
        }
        setToastType("error");
        setToastMessage("Unable to delete module. Please try again later");
        setOpenToast(true);
      } finally {
        setDisableDelete(false);
      }
    };

    if (!Object.keys(item).length) return null;
    return (
      <>
        <div
          className="admin-path-module-container"
          ref={ref}
          onClick={() => onClick(item)}
          style={style}
        >
          <div className="admin-path-module-Info-wrapper">
            <div className="admin-path-module-title-wrapper">
              <GridIcon className="admin-path-module-reorder-icon" />
              <h4 className="admin-path-module-title">{item.moduleName}</h4>
            </div>
            <div className="admin-path-module-util-btn-wrapper">
              {/* <Button
                className="admin-path-module-preview-btn"
                size="sm"
                hierarchy={{ type: "tertiaryGrey", buttonText: "Preview" }}
                icon={{
                  icon: (
                    <svg
                      width="20"
                      height="15"
                      viewBox="0 0 20 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.833008 7.50163C0.833008 7.50163 4.16634 0.834961 9.99967 0.834961C15.833 0.834961 19.1663 7.50163 19.1663 7.50163C19.1663 7.50163 15.833 14.1683 9.99967 14.1683C4.16634 14.1683 0.833008 7.50163 0.833008 7.50163Z"
                        stroke="#667085"
                        strokeWidth="1.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M9.99967 10.0016C11.3804 10.0016 12.4997 8.88234 12.4997 7.50163C12.4997 6.12092 11.3804 5.00163 9.99967 5.00163C8.61896 5.00163 7.49967 6.12092 7.49967 7.50163C7.49967 8.88234 8.61896 10.0016 9.99967 10.0016Z"
                        stroke="#667085"
                        strokeWidth="1.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ),
                  type: "leading",
                }}
              /> */}
              {!item.isPublished && isSharedLP === 0 &&  (
                <Tooltip title="Delete" isIcon>
                  <IconButton
                    hierarchy="tertiaryGrey"
                    destructive
                    className="admin-path-module-delete-btn"
                    onClick={(event) => onDeleteModule(event, item.moduleId)}
                    disabled={disableDelete}
                  >
                    <svg
                      width="17"
                      height="19"
                      viewBox="0 0 17 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.834961 4.16829H2.50163M2.50163 4.16829H15.835M2.50163 4.16829V15.835C2.50163 16.277 2.67722 16.7009 2.98978 17.0135C3.30234 17.326 3.72627 17.5016 4.16829 17.5016H12.5016C12.9437 17.5016 13.3676 17.326 13.6801 17.0135C13.9927 16.7009 14.1683 16.277 14.1683 15.835V4.16829H2.50163ZM5.00163 4.16829V2.50163C5.00163 2.0596 5.17722 1.63568 5.48978 1.32312C5.80234 1.01056 6.22627 0.834961 6.66829 0.834961H10.0016C10.4437 0.834961 10.8676 1.01056 11.1801 1.32312C11.4927 1.63568 11.6683 2.0596 11.6683 2.50163V4.16829M6.66829 8.33496V13.335M10.0016 8.33496V13.335"
                        stroke="#B42318"
                        strokeWidth="1.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </IconButton>
                </Tooltip>
              )}
            </div>
          </div>
          <div className="admin-path-module-number">
            Module {Number(item.moduleOrderno) / 100000 ?? 1}
          </div>
          {/* <div className="admin-path-module-description"> */}
          <ReactQuill
            className="admin-path-module-description"
            readOnly={true}
            value={item.moduleDesc}
          />
          {/* </div> */}
          <div className="admin-path-module-overall-details-wrapper">
            <ModuleStatusLabel
              item={{ type: "Content", count: item.contentCount || 0 }}
            />
            <ModuleStatusLabel
              item={{ type: "Videos", count: item.videoContentCount || 0 }}
            />
            <ModuleStatusLabel
              item={{ type: "Assignment", count: item.assignmentCount || 0 }}
            />
            <ModuleStatusLabel
              item={{ type: "Assessment", count: item.assessmentCount || 0 }}
            />
          </div>
          <Modal
            isOpen={openModal}
            onClose={() => setOpenModal(false)}
            showCloseIcon={false}
            className="config-topic-confirmation-modal"
          >
            <ModalBody
              content={
                <>
                  <p className="config-topic-confirmation-modal-title">
                    Delete Module
                  </p>
                  <p className="config-topic-confirmation-modal-content">
                    Are you sure you want to delete the module?
                  </p>
                </>
              }
              footer={
                <div className="config-topic-confirmation-footer">
                  <Button
                    size="sm"
                    hierarchy={{ type: "secondaryGrey", buttonText: "Cancel" }}
                    onClick={() => setOpenModal(false)}
                  />
                  <Button
                    size="sm"
                    hierarchy={{
                      type: "primary",
                      buttonText: disableDelete ? "Deleting" : "Delete",
                    }}
                    destructive={true}
                    disable={disableDelete}
                    onClick={() => onConfirmDeleteModule(item.moduleId)}
                  />
                </div>
              }
            />
          </Modal>
        </div>
        <Toast
          open={openToast}
          type={toastType}
          message={toastMessage}
          onClose={() => setOpenToast(false)}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        />
      </>
    );
  },
);

export default Module;
